import { upperFirst } from 'lodash';
import { CommanderThunkAction } from '@mews-commander/types';
import { createEmptyAction, createFetchAction } from '@mews-commander/utils';

export function actionsFactory({
    name,
    baseAction,
    lastUpdateSelector,
    fetchUrl,
    cacheDuration = 60 * 60 * 1000,
}: $TSFixMe) {
    const url = fetchUrl || `/${name}/getAll`;
    return {
        [`fetch${upperFirst(name)}`]:
            (fetchArguments: $TSFixMe): CommanderThunkAction =>
            async (dispatch, getState, { container, appClockService }) => {
                const updateNeeded = appClockService.getValue() - lastUpdateSelector(getState()) > cacheDuration;
                if (!updateNeeded) {
                    return dispatch(createEmptyAction());
                }

                const promise = container()
                    .apiComponent.request(url, fetchArguments)
                    .then((entities: $TSFixMe) => ({
                        [name]: entities,
                        lastUpdate: appClockService.getValue(),
                    }));
                return dispatch(createFetchAction(baseAction, { promise }));
            },
    };
}
